import { useContext } from "react";
import { ERROR } from 'services/common/Constants';
import EAButton from "components/common/EAButton";
import EAIcon from "components/common/EAIcon";
import i18next from "i18next";
import { stopEvaluation } from "services/edge/EcovadisService";
import { Context } from "states/Store";


const EcovadisStopEvaluationButton = ({disabled = true, onRiskChange = () => {}}) => {
  const [state, dispatch] = useContext(Context);

  const stopEvaluationHandler = async () => {
    try {
      await stopEvaluation(
        state.account.id,
        state.thirdparty.thirdpartyId
      );
      onRiskChange();
    } catch (error) {
      dispatch({
        type: 'ALERT',
        alert: {
          type: ERROR,
          msg: error?.message?.messages?.error?.[0]?.code || 'INTERNAL_ERROR',
        },
      });
    }
  };

  return (
    <>
      <EAButton
        size="small"
        onClick={stopEvaluationHandler}
        colorVariant="errorLight"
        customStyle={{boxShadow: "none", minHeight: "30px" }}
        disabled={disabled}
        content={
          <>
            <EAIcon icon="stop_scoring" />
            <span>{i18next.t('ecovadis.stopEvaluation')}</span>
          </>
        }
      />
    </>
  )
};

export default EcovadisStopEvaluationButton;